module.exports = __webpack_public_path__ + "img/vertical_3_1_5010.3527283d.png";